module.exports = __webpack_public_path__ + "img/car.356190d8.svg";